// Shared between Forgot password and Reset password.
// The reset email can be opened on the same device it was asked for from,
// so we remember the email (to prefill) and where they were heading (e.g.
// /payouts from the Stripe reminder) to send them back there afterwards.
const KEY = 'hireit_password_reset'

// Always the main domain (www forwards to the home page and drops the path)
export const SITE_URL = typeof window !== 'undefined' && window.location.hostname === 'localhost'
  ? window.location.origin
  : 'https://hireitnow.au'

export const safeNext = (p) => (p && p.startsWith('/') && !p.startsWith('//') ? p : null)

export function rememberReset({ email, next }) {
  try { localStorage.setItem(KEY, JSON.stringify({ email, next: safeNext(next), at: Date.now() })) } catch (e) {}
}

export function recalledReset() {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null')
    if (saved && Date.now() - saved.at < 24 * 60 * 60 * 1000) return saved
  } catch (e) {}
  return {}
}

export function forgetReset() {
  try { localStorage.removeItem(KEY) } catch (e) {}
}

// Supabase error → plain English
export function describeResetError(error) {
  const msg = (error?.message || '').toLowerCase()
  if (error?.status === 429 || msg.includes('rate limit') || msg.includes('security purposes')) {
    return 'Please wait a minute before asking for another email.'
  }
  if (msg.includes('expired') || msg.includes('invalid') || msg.includes('not found')) {
    return 'That code or link has expired or has already been used. Please ask for a new one.'
  }
  if (msg.includes('same') && msg.includes('password')) return 'Please choose a different password from your old one.'
  if (msg.includes('session')) return 'This reset link has expired. Please ask for a new one.'
  return error?.message || 'Something went wrong. Please try again.'
}
